<app-button
  data-cy="book-filter"
  [size]="'small'"
  [color]="'pink'"
  [icon]="'assets/icon/burger.svg'"
  [iconPlacement]="'end'"
  [shape]="'circle'"
  (clicked)="displayFilter()" />
